import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MyBookingsService } from 'src/app/bookings/my-bookings/my-bookings.service';
import { DropdownItem } from 'mis-crystal-design-system/dropdown';
import { BaseFormGroup } from '../base-form-group';

@Component({
  selector: 'app-engagement-code-input',
  templateUrl: './engagement-code-input.component.html',
  styleUrls: ['./engagement-code-input.component.scss']
})
export class EngagementCodeInputComponent extends BaseFormGroup implements OnInit, OnDestroy {
  @Input() ridersFormArray: FormArray;
  @Input() engagementForm: FormGroup;
  
  selectedEmpFormGrp: any;
  codeControl: FormControl = new FormControl("", Validators.required);
  tooltipMessage = "";
  selectedEmp: string;
  employees: DropdownItem[] = [];
  emplGuid: string;
  engagementDetails: any;
  verificationStatus: 'not_verified' | 'verifying' | 'verified' | 're_verify' = 'not_verified';
  constructor(
    private myBookingService: MyBookingsService,
  ) {
    super();
  }

  ngOnInit(): void {
    if(this.ridersFormArray){
      for(let riderFormGroup of this.ridersFormArray.controls){
        if(riderFormGroup.get('riderTypeId')?.value.toLowerCase()!=='guest'){
          this.employees.push({
            label: riderFormGroup.get('name').value,
            value: riderFormGroup.get('emplGuid').value
          });
        }
      }
      this.ridersFormArray.setErrors({invalidCode: true});
    }

    this.codeControl.disable();
  }

  onEmployeeSelect(selectedEmp: DropdownItem){
    this.resetVerification();
    this.selectedEmp = selectedEmp?.label;
    this.emplGuid = selectedEmp?.value
    
    this.selectedEmpFormGrp = this.ridersFormArray.controls.find((fg)=> fg.get('emplGuid')?.value === selectedEmp.value);
  }

  verifyCode(){
    this.engagementDetails = null;
    this.verificationStatus = 'verifying';
    const code = this.codeControl.value;
    const data = {
      [this.emplGuid]: code
    };

    this.myBookingService.verifyEngagementCode(data).subscribe((res) => {
      const response = JSON.parse(res); 
      if (response) {
        if (response.status?.toLowerCase() === 'success'){
          this.verificationStatus = 'not_verified';
          this.ridersFormArray.setErrors(null);
          this.selectedEmpFormGrp.setErrors(null);
          this.selectedEmpFormGrp.get('engagementCode').setValue(code);
          this.engagementForm.patchValue(response);
          this.engagementDetails = {
            engagementCode: response.engagementCode || code,
            manager:{
              name: response.manager?.name || '-',
              id: response.manager?.id || '-',
              email: response.manager?.email || '-'
            },
            partner:{
              name: response.partner?.name || '-',
              id: response.partner?.id || '-',
              email: response.partner?.email || '-'
            },
            billableType: response.billableType
          }
          this.codeControl.reset();
        } else {
          this.codeControl.disable();
          this.ridersFormArray.setErrors({invalidCode: true});
          this.verificationStatus = 're_verify';
          this.tooltipMessage = "Invalid Code! Try again.";
        }
      }
    }, (err) => {
      this.codeControl.disable();
      this.ridersFormArray.setErrors({invalidCode: true});
      this.verificationStatus = 're_verify';
      this.tooltipMessage = "Something went wrong. Try again.";
    });
  }

  resetVerification(){
    for(let riderFormGroup of this.ridersFormArray.controls){
      if(riderFormGroup instanceof UntypedFormGroup){
        if(riderFormGroup.get('engagementCode')){
          riderFormGroup.get('engagementCode').reset();
        } else {
          riderFormGroup.addControl('engagementCode', new FormControl(null));
        }
      }
    }
    this.ridersFormArray.setErrors({invalidCode: true});
    this.engagementDetails = null;
    this.codeControl.enable();
    this.codeControl.reset();
    this.verificationStatus = 'not_verified';
  }

  ngOnDestroy(){
    this.ridersFormArray.setErrors(null);
  }

}
